<template>
  <div class="courselist_box">
    <div class="courselist_header">
      <div class="back_to_list">
        <a-icon class="ZHIHUISHU_QZMD" type="left" @click="$router.back()" />
        <span class="ZHIHUISHU_QZMD" @click="$router.back()" v-if="!isEditCourseName">{{ courseName }}</span>
        <a-input
          @keyup.enter.prevent.stop="editCourseName"
          :placeholder="courseName"
          v-model="courseName"
          v-if="isEditCourseName"
          :maxlength="20"
        />
        <a-icon
          style="font-size: 18px"
          type="edit"
          theme="filled"
          class="ZHIHUISHU_QZMD"
          @click="isEditCourseName = !isEditCourseName"
          v-if="!isEditCourseName"
        />
        <template v-if="isEditCourseName">
          <div class="course_name_edit_btn_group">
            <span class="course_name_edit_cancel" @click="handleCourseNameEditCancel">取消</span>
            <span class="course_name_edit_confirm" @click="editCourseName">保存</span>
          </div>
        </template>
      </div>
      <div>
        <a-button icon="share-alt" type="default" class="ZHIHUISHU_QZMD" @click="getInvitationCode('', 2)">
          分享课程参加码
        </a-button>
        <a-button
          type="primary"
          style="margin-left: 30px"
          class="ZHIHUISHU_QZMD"
          @click="toggleCreateLiveModal(true, 'add')"
        >
          <a-icon type="plus-circle" theme="filled" />
          添加直播
        </a-button>
        <a-button type="primary" style="margin-left: 30px" class="ZHIHUISHU_QZMD" @click="downloadList">
          <a-icon type="download" />
          导出
        </a-button>
      </div>
    </div>
    <div class="count_box">
      <div>
        <div>
          授课周期：
          <span>
            {{ startTime }}
            <span v-show="endTime">~</span>
            {{ endTime }}
          </span>
        </div>
        <div>
          课程进度：
          <span>{{ progress }}</span>
        </div>
      </div>
      <div>一门课程只有一个课程参加码，每节课都可用该参加码上课</div>
    </div>
    <div class="classroom-manage">
      <a-table
        :columns="columns"
        :data-source="liveList"
        :row-key="(record, index) => record.id"
        :pagination="false"
        :loading="tabLoading"
        :customRow="customRow"
      >
        <template slot="statusDesc" slot-scope="text, record">
          <a-tag :color="record.status | filterCourseListStatusTag">{{ text }}</a-tag>
        </template>
        <template slot="liveName" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="liveCode" slot-scope="text, record">
          <p :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</p>
          <p v-if="record.lcLiveid" :class="record.status == '2' ? 'end_gray' : ''">LC:{{ record.lcLiveid }}</p>
        </template>
        <template slot="isSafeguard" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="className" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="watchList" slot-scope="text, record">
          <div v-if="text.length">
            <span v-for="(item, index) in text" :key="item" :class="record.status == '2' ? 'end_gray' : ''">
              {{ item }}
              <span v-if="text.length > 1 && index != text.length - 1">;</span>
            </span>
          </div>
          <div v-if="text.length == 0">
            <span :class="record.status == '2' ? 'end_gray' : ''">--</span>
          </div>
        </template>
        <template slot="teacherName" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="teacherPhone" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="startTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="endTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="updateTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="action_box">
            <a-tooltip v-show="record.status == 2">
              <template slot="title">回放</template>
              <img
                @click.prevent.stop="backVideoPlay(record)"
                style="width: 20px; height: 20px; cursor: pointer; margin-right: 5px"
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/dc10ac55ef3d48ac807d0bc4a266c02c.png"
                alt=""
              />
            </a-tooltip>
            <a-tooltip>
              <template slot="title">分享</template>
              <!-- <img
                @click.prevent.stop="getInvitationCode(record, 1)"
                style="width: 20px; height: 20px; cursor: pointer; margin-right: 5px"
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/c054994da71046a19233444553407961.png"
                alt=""
              /> -->
              <img
                @click.prevent.stop="handleAction(record, 'share')"
                style="width: 20px; height: 20px; cursor: pointer; margin-right: 5px"
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/c054994da71046a19233444553407961.png"
                alt=""
              />
            </a-tooltip>
            <a-tooltip v-show="record.status == 0">
              <template slot="title">编辑</template>
              <img
                @click.prevent.stop="getLiveEditDetail(record)"
                style="width: 20px; height: 20px; cursor: pointer; margin-right: 5px"
                src="//image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202112/46a7e06fcac24d05924febf2c4b69f42.png"
                alt=""
              />
            </a-tooltip>
            <a-tooltip>
              <template slot="title">删除</template>
              <img
                @click.prevent.stop="showDeleteConfirm(record)"
                style="width: 20px; height: 20px; cursor: pointer; margin-right: 5px"
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/b2b0fcd1a994443dbb8f1a1c05a34b04.png"
                alt=""
              />
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>
    <my-dialog @hideMask="dialogFlag = false" :dialogFlag="dialogFlag" width="400px" p_lr="0">
      <div class="dialog_inner_container">
        <div class="dialog_inner_container_header">分享{{ isClassShare ? '课程' : '直播' }}参加码</div>
        <div class="dialog_inner_container_body">
          <div class="share_list">
            <div
              class="share_item"
              v-for="item in shareList"
              :key="item.title"
              v-show="item.show || (isClassShare && courseType == '3')"
            >
              <div class="share_item_top">
                <span class="share_item_top_title">{{ item.title }}：</span>
                <span class="share_item_top_body">{{ item.joinCode }}</span>
              </div>
              <div class="share_item_bottom">
                {{ item.explainText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </my-dialog>
    <!-- video: -->
    <drawer-for-vue-core-video-player
      @hideMaskForDrawer="hideMaskForDrawer"
      :drawerFlag="drawerFlag"
      :videoSrc="videoSrc"
      :videoSrcList="videoSrcList"
      @videoSrcChangeByChild="videoSrcChangeByChild"
    />
    <!-- <class-modal
      :courseInfo="courseInfo"
      :showModalProp.sync="showModal"
      :editFormData="editFormData"
      :editModel="editModel"
      @refresh="getCourseLiveList"
      @close="closeModel"
    ></class-modal> -->
    <create-live-modal
      :courseInfo="courseInfo"
      :liveDetail="liveEditDetail"
      :schoolList="checkedSchool"
      :showModal="showCreateLiveModal"
      @refresh="getCourseLiveList"
      @close="toggleCreateLiveModal"
    ></create-live-modal>
    <!-- delete: -->
    <my-dialog @hideMask="dialogFlagForDelete = false" :dialogFlag="dialogFlagForDelete" width="330px" p_lr="0">
      <div class="dialog_inner_container_for_delete">
        <div class="dialog_inner_container_for_delete_header">提示</div>
        <div class="dialog_inner_container_for_delete_body">直播删除后无法恢复，请谨慎操作</div>
        <div class="dialog_inner_container_for_delete_footer">
          <div
            :class="[
              'dialog_inner_container_for_delete_footer_inner_item',
              index === 1 ? 'm_l15' : '',
              'ZHIHUISHU_QZMD'
            ]"
            v-for="(item, index) in deleteOperationList"
            :key="item.title"
            :style="{
              backgroundColor: item.bgc,
              border: item.border,
              color: item.color
            }"
            @click="deleteOperationItemClick(item)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="loading_mask" v-if="dialogLoadingForDelete">
          <a-spin />
        </div>
      </div>
    </my-dialog>
    <!-- share -->
    <share-dialog :shareDialogFlag.sync="shareDialogFlag" :rowDetail="rowDetail" style="text-align: left" />
  </div>
</template>

<script>
import { Row } from 'ant-design-vue'
import { mapGetters } from 'vuex'
import { ROOM_TYPE_ENUM } from '../../components/classModal/const'
import { checkRes } from '../../utils/tool'
import { editLiveDisplayInfo } from '@/server/api/courseManage'

const columns = [
  {
    title: '状态',
    width: 86,
    dataIndex: 'statusDesc',
    scopedSlots: { customRender: 'statusDesc' }
  },
  {
    title: '直播名称',
    dataIndex: 'liveName',
    // align: 'center',
    scopedSlots: { customRender: 'liveName' },
    customHeaderCell: (column) => {
      return {
        style: {
          'min-width': '90px'
        }
      }
    }
  },
  {
    title: 'ID',
    width: 136,
    dataIndex: 'liveCode',
    scopedSlots: { customRender: 'liveCode' }
  },
  {
    title: '直播保障',
    width: 90,
    dataIndex: 'isSafeguard',
    scopedSlots: { customRender: 'isSafeguard' }
  },
  {
    title: '主讲学校-教室',
    // align: 'center',
    dataIndex: 'className',
    scopedSlots: { customRender: 'className' },
    customHeaderCell: (column) => {
      return {
        style: {
          'min-width': '90px'
        }
      }
    }
  },
  {
    title: '听课学校-教室',
    // align: 'center',
    dataIndex: 'watchList',
    scopedSlots: { customRender: 'watchList' },
    customHeaderCell: (column) => {
      return {
        style: {
          'min-width': '90px'
        }
      }
    }
  },
  {
    title: '主讲老师',
    width: 90,
    dataIndex: 'teacherName',
    scopedSlots: { customRender: 'teacherName' }
  },
  {
    title: '主讲手机',
    width: 130,
    dataIndex: 'teacherPhone',
    scopedSlots: { customRender: 'teacherPhone' }
  },
  {
    title: '开始时间',
    width: 145,
    dataIndex: 'startTime',
    scopedSlots: { customRender: 'startTime' }
  },
  {
    title: '结束时间',
    width: 145,
    dataIndex: 'endTime',
    scopedSlots: { customRender: 'endTime' }
  },
  // {
  //   title: '最近编辑',
  //   width: 145,
  //   dataIndex: 'updateTime',
  //   scopedSlots: { customRender: 'updateTime' },
  // },
  {
    title: '操作',
    align: 'right',
    width: 115,
    key: 'id',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  components: {
    'class-modal': () => import('../../components/classModal/index'),
    'my-dialog': () => import('../../components/my_dialog'),
    'my-drawer': () => import('../../components/my_drawer'),
    'drawer-for-vue-core-video-player': () =>
      import('../../components/componentsForPage/drawer_for_vue_core_video_player'),
    'create-live-modal': () => import('./comp/createCourse/CreateLiveModal'),
    'share-dialog': () => import('./LiveStreamingList/comp/ShareDialog.vue')
  },
  data() {
    return {
      showCreateLiveModal: false,
      checkedSchool: [],
      liveEditDetail: {},

      dialogFlag: false,
      showModal: false,
      columns,
      courseId: '',
      courseName: '',
      progress: '',
      endTime: '',
      startTime: '',
      liveList: [],
      shareList: [
        {
          title: '老师参加码',
          joinCode: '- -',
          explainText: '老师参加码只能发送给主讲老师，泄漏后可能造成直播异常',
          show: true
        },
        {
          title: '听课教室参加码',
          joinCode: '- -',
          explainText: '听课/互动教室的助教，在“知到-教师版”APP输入该参加码，加入直播课堂',
          show: true
        },
        {
          title: '观摩旁听参加码',
          joinCode: '- -',
          explainText: '个体学生，在“知到”APP输入该参加码，看直播、回放',
          show: true
        }
      ],
      isEditCourseName: false,
      editFormData: {},
      editModel: {
        show: false,
        liveType: 'simple',
        liveId: ''
      },
      courseInfo: {
        show: false,
        classId: ''
      },
      drawerFlag: false,
      videoSrc: '',
      videoSrcList: [],
      tabLoading: false,
      isClassShare: false,
      courseType: '',
      customRow: (record, index) => ({
        on: {
          click: () => {
            // 单元行点击事件
            this.operationForGoSupervision(record)
          }
        }
      }),
      dialogFlagForDelete: false,
      dialogLoadingForDelete: false,
      deleteOperationList: [
        {
          title: '确定删除',
          bgc: '#FFF',
          border: '1px solid #D9D9D9',
          color: '#595959',
          type: 0
        },
        {
          title: '取消删除',
          bgc: '#2090FF',
          border: 'none',
          color: '#FFF',
          type: 1
        }
      ],
      deleteData: {},
      // share
      shareDialogFlag: false,
      rowDetail: {},
      // course detail
      courseDetail: {}
    }
  },
  filters: {
    filterCourseListStatusTag(liveStatus) {
      let res = 'blue'
      switch (String(liveStatus)) {
        case '0':
          res = 'blue'
          break
        case '1':
          res = 'green'
          break
        case '2':
          res = 'orange'
          break
      }
      return res
    }
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo'])
  },
  created() {
    let dom = document.getElementsByClassName('ant-layout-content')[0] || {}
    dom.scrollTop = 0
    this.courseId = this.$route.query.id
    this.courseInfo = {
      show: true,
      courseId: this.courseId
    }
    this.getCheckedSchool()
    this.getCourseDetail()
    this.getCourseLiveList()
  },
  methods: {
    toggleCreateLiveModal(bl, option) {
      if (option === 'add') {
        this.liveEditDetail = {}
      }
      this.showCreateLiveModal = bl
    },
    getCheckedSchool() {
      this.$http.getSelectSchoolList().then((res) => {
        if (res.rt) {
          this.checkedSchool = res.rt || []
        }
      })
    },
    // 获取直播可编辑详情
    async getLiveEditDetail(info) {
      const self = this
      const res = await editLiveDisplayInfo({ liveId: info.id })
      checkRes({
        res,
        success(data) {
          self.liveEditDetail = data.rt
          self.toggleCreateLiveModal(true, 'edit')
        },
        failed() {
          self.$message.error('获取课程详情失败')
        }
      })
    },
    /**
     * @description: 导出直播列表
     * @param {*}
     * @return {*}
     */
    async downloadList() {
      let data = await this.$http.exportCourseLiveList({
        courseId: this.courseId
      })
      const blob = new Blob([data], {
        type: 'application/vnd.ms-excel'
      })
      const objectUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objectUrl
      a.download = this.courseName + '直播列表.xlsx'
      a.click()
      document.body.removeChild(a)
    },
    async operationForGoSupervision(item) {
      // 现采用新版本的逻辑：
      const { classroomCode, status: liveStatus, liveId = '', mscId } = item
      switch (liveStatus) {
        case 0:
        case 1:
          if (classroomCode) {
            this.$router.push({
              name: 'InspectionTourDetail',
              query: {
                liveId,
                classroomCode
              }
            })
          } else {
            window.open(`https://zhs-livecourse.zhihuishu.com/teacher/IndividualStudent?liveId=${liveId}`, '_blank')
          }
          break
        case 2:
          // this.backVideoPlay(videoId ? [videoId] : [])
          // this.backVideoPlay(videoId)
          const role = '0'
          // const href = `https://tju-livecourse.zhihuishu.com/primary/#/playback?mscId=${mscId}&id=${liveId}&role=${role}`
          const href = `https://zhs-livecourse.zhihuishu.com/primary/#/playback?mscId=${mscId}&id=${liveId}&role=${role}`
          window.open(href, '_blank')
          break
      }
      // 旧版本的逻辑全部暂时注释：
      // let { id, status, liveType, videoId } = item
      // if (status != 1 && status != 2) return this.$message.warning('直播不在进行中，暂不支持进入督学页面')
      // // if (status == 2) return await this.backVideoPlay({ videoId })
      // if (status == 2) {
      //   window.open(`https://tp.zhihuishu.com/#/playback?role=0&id=${id}`, '_blank')
      //   // window.open(`https://www.livecourse.com/playback?id=${id}`, '_blank')
      //   return
      // }
      // if (liveType == 2 || liveType == 4 || liveType == 5) {
      //   let { href } = this.$router.resolve({
      //     name: 'LCSupervisionCourse',
      //     query: { liveId: id, userId: this.userInfo.userId }
      //   })
      //   window.open(href, '_blank')
      // } else {
      //   switch (item.liveOrigin) {
      //     case 4:
      //     case 6:
      //       const { href: clientSupervisionCourseHref } = this.$router.resolve({
      //         name: 'ClientSupervisionCourse',
      //         query: { liveId: id, userId: this.userInfo.userId }
      //       })
      //       window.open(clientSupervisionCourseHref, '_blank')
      //       break
      //     default:
      //       const { href: supervisionCourseHref } = this.$router.resolve({
      //         name: 'SupervisionCourse',
      //         query: { liveId: id, userId: this.userInfo.userId }
      //       })
      //       window.open(supervisionCourseHref, '_blank')
      //       break
      //   }
      //   let { href } = this.$router.resolve({
      //     name: 'SupervisionCourse',
      //     query: { liveId: id, userId: this.userInfo.userId }
      //   })
      //   window.open(href, '_blank')
      // }
    },
    async getVideoUrl(videoID) {
      // 直接照搬以前的逻辑
      // 老接口：
      // let result = await this.$http.getVideoById({
      //     videoID
      // })
      // 新接口：
      let result = await this.$http.getVideoByIdNew({
        videoID
      })
      result = result.data
      if (result.errorCode !== 0) return this.$message.error(result.errorMsg)
      let videoObj = (result.result.lines || []).find((item) => item.lineUrl) || {}
      if (!videoObj) return this.$message.error('抱歉，暂无视频哦')
      let videoSrc = ''
      videoSrc = videoObj.lineUrl
      return videoSrc
    },
    // 获取视频：
    // backVideoPlay({ videoId } = record) {
    backVideoPlay(record) {
      this.operationForGoSupervision(record)
      // 以下是老逻辑：
      return
      if (!videoId) return this.$message.error('课程结束1小时后生成回放，请稍后重试！如有问题请联系智慧树运维客服！')
      if (!videoId.length)
        return this.$message.error('课程结束1小时后生成回放，请稍后重试！如有问题请联系智慧树运维客服！')
      this.$nextTick(async () => {
        let videoUrl = []
        if (typeof videoId == 'string') {
          videoUrl = videoId.split(',') || []
        } else {
          videoUrl = videoId
        }
        // this.videoSrc = await this.getVideoUrl(videoUrl)
        // this.drawerFlag = true
        this.videoSrcList = []
        // 首先获取到所有的视频，默认播放第一个：
        for (let i = 0, len = videoUrl.length; i < len; i++) {
          try {
            let videoSrc = await this.getVideoUrl(videoUrl[i])
            this.videoSrcList.push(videoSrc)
          } catch (err) {
            console.log(err, 'err')
          }
        }
        if (this.videoSrcList.length) {
          this.videoSrc = this.videoSrcList[0]
          this.drawerFlag = true
        }
      })
    },
    hideMaskForDrawer() {
      this.drawerFlag = false
    },
    closeModel() {
      this.editModel = {
        show: false,
        liveType: 'simple',
        liveId: ''
      }
      this.editFormData = {}
    },
    // 编辑直播
    async editLiveDetail(record) {
      // 1 小程序极简教室
      // 2 共享课LC互动
      // 3 后台纯极简教室 无导播
      // 4 后台LC互动
      // 5 后台极简教室
      let res = {}
      let liveType = ''
      if (record.liveType == '3') {
        liveType = ROOM_TYPE_ENUM.SIMPLE
        // simple
        res = await this.$http.getSimpleLiveInfo({
          liveId: record.id
        })
      } else if (record.liveType == '4' || record.liveType == '5') {
        // wisdom smallest
        liveType = record.liveType == '4' ? ROOM_TYPE_ENUM.WISDOM : ROOM_TYPE_ENUM.SMALLEST
        res = await this.$http.getLcLiveInfo({
          liveId: record.id
        })
      }
      if (res.code !== 200) {
        return this.$message.error(res.msg || '获取详情失败!')
      }
      this.editFormData = res.rt
      this.editModel = {
        show: true,
        liveType,
        liveId: record.id
      }
      this.showModal = true
    },
    async getInvitationCode(record, status) {
      let res = await this.$http.getInvitationCode({
        id: record.id || this.courseId,
        type: status
      })
      if (res.code !== 200) {
        return this.$message.error(res.msg || '获取邀请码失败！')
      }
      res.rt[record.id || this.courseId]?.forEach((item, index) => {
        this.shareList[index].joinCode = item.inviteCode ? item.inviteCode : '- -'
      })
      // 20220906 针对课程邀请码，产品要求不区分直播模式，都要展示主讲的邀请码
      // if (record.liveType == '3' || record.liveType == '5') {
      //   this.shareList[0].show = true
      // } else {
      //   this.shareList[0].show = false
      // }
      if (!record) {
        this.isClassShare = true
      } else {
        this.isClassShare = false
      }
      this.dialogFlag = true
    },
    async getCourseLiveList() {
      this.tabLoading = true
      let res = await this.$http.getCourseLiveList({
        courseId: this.courseId
      })
      this.tabLoading = false
      if (res.code !== 200) {
        return this.$message.error(res.msg || '获取课程下直播列表失败！')
      }
      this.liveList = res.rt
    },
    handleCourseNameEditCancel() {
      this.courseName = this.courseDetail.courseName || ''
      this.isEditCourseName = false
    },
    async editCourseName() {
      if (this.courseName.length > 50) {
        return this.$message.error('课程名称不得大于50个字')
      }
      if (this.courseName.trim().length == 0) {
        this.courseName = this.courseDetail.courseName || ''
        return this.$message.error('课程名称不可为空')
      }
      let res = await this.$http.editCourseName({
        courseId: this.courseId,
        courseName: this.courseName
      })
      this.isEditCourseName = false
      if (res.rt.resultStatus == -1 || res.code != 200) {
        return this.$message.error(res.rt.resultMessage || '修改课程名失败！')
      }
      this.getCourseDetail()
    },
    async getCourseDetail() {
      let res = await this.$http.getCourseDetail({
        courseId: this.courseId
      })
      if (res.code !== 200) {
        return this.$message.error(res.msg || '请求课程列表失败！')
      }
      this.courseDetail = res.rt || {}
      this.courseName = res.rt.courseName
      this.endTime = res.rt.endTime
      this.startTime = res.rt.startTime
      this.progress = res.rt.progress
      this.courseType = res.rt.courseType
    },
    // delete：
    async deleteOperationItemClick({ type }) {
      switch (type) {
        case 0:
          try {
            this.dialogLoadingForDelete = true
            let result = await this.$http.delCourseLive({
              liveId: this.deleteData.id
            })
            this.dialogLoadingForDelete = false
            if (result.code !== 200) return this.$message.error(result.msg)
            let { rt: resultReally } = result
            if (resultReally.resultStatus !== 1)
              return this.$message.error(resultReally.resultMessage ? resultReally.resultMessage : '删除失败')
            this.$message.success('删除成功')
            this.dialogFlagForDelete = false
            this.getCourseDetail()
            this.getCourseLiveList()
          } catch (err) {
            console.log(err)
          }
          break
        case 1:
          this.dialogFlagForDelete = false
          break
      }
    },
    showDeleteConfirm(record) {
      this.dialogFlagForDelete = true
      this.deleteData = record
    },
    videoSrcChangeByChild(videoSrc) {
      this.videoSrc = videoSrc
    },
    async handleAction(record, action) {
      switch (action) {
        case 'share':
          this.shareDialogFlag = true
          let res = await this.$http.getInvitationCode({
            id: record.id,
            type: 1
          })
          if (res.code !== 200) {
            return this.$message.error(res.msg || '获取邀请码失败！')
          }
          const recordNew = {
            ...record,
            assistantInviteCode: (res.rt[record.id][1] || {}).inviteCode || '- -',
            studentInviteCode: (res.rt[record.id][2] || {}).inviteCode || '- -',
            liveId: record.id
          }
          this.rowDetail = recordNew
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin dialogTitle($color) {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
  color: $color;
  font-size: 16px;
  border-radius: 10px 10px 0 0;
  padding: 0 30px;
  border-bottom: 1px solid #e7e7e7;
}
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scaleCircle {
  from {
    transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(100);
  }
}

.end_gray {
  color: #bfbfbf;
}
.courselist_box {
  min-width: 1300px;
  // 全局中添加以下样式
  ::v-deep.ant-table-fixed-header .ant-table-scroll .ant-table-header {
    width: calc(100% - 8px); //减去滚动条的宽度
  }
  // share:
  .dialog_inner_container {
    .dialog_inner_container_header {
      @include dialogTitle(#222);
    }
    .dialog_inner_container_body {
      width: 100%;
      height: auto;
      padding: 20px 30px 10px;
      border-radius: 0 0 10px 10px;
      .share_list {
        .share_item {
          width: 100%;
          height: auto;
          padding-bottom: 10px;
          margin-bottom: 20px;
          text-align: left;
          .share_item_top {
            font-weight: bold;
            font-size: 14px;
            position: relative;
            padding-left: 10px;
            .share_item_top_body {
              color: #2090ff;
            }
            &::before {
              content: '';
              width: 3px;
              height: 16px;
              background-color: #1a90ff;
              border-radius: 2px;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          .share_item_bottom {
            font-size: 14px;
            color: #858492;
            margin-top: 6px;
          }
          &:nth-of-type(1) {
            .share_item_bottom {
              color: #fe7c14;
            }
          }
        }
      }
    }
  }
  ::v-deep {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      border-bottom: 0;
    }
    .ant-table-thead > tr > th {
      background: #f6f6f6;
    }
    .ant-table-tbody {
      tr:nth-child(even) {
        background: #f4f7fa;
      }
      .ant-table-row {
        cursor: pointer;
      }
    }
    .action {
      text-align: center;
      .action-icon {
        cursor: pointer;
      }
    }
    .ant-table-pagination {
      float: none;
      text-align: center;
    }
  }
  .courselist_header {
    background-color: #fff;
    box-shadow: 0 0 10px #ddd;
    padding: 25px;
    display: flex;
    justify-content: space-between;
    .back_to_list {
      cursor: pointer;
      display: flex;
      align-items: center;
      > input:nth-child(2) {
        margin-left: 15px;
      }
      > span:nth-child(2) {
        margin-left: 15px;
        font-weight: bold;
      }
      > i:nth-child(3) {
        margin-left: 15px;
        :hover {
          color: skyblue;
        }
      }
      .course_name_edit_btn_group {
        display: flex;
        align-items: center;
        width: 150px;
        height: 100%;
        margin-left: 15px;
      }
      .course_name_edit_cancel,
      .course_name_edit_confirm {
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
      }
      .course_name_edit_cancel {
        color: #91959c;
        margin-right: 15px;
        &:hover {
          color: #6f7278;
        }
        &:active {
          color: #91959c;
        }
      }
      .course_name_edit_confirm {
        color: #1a90ff;
        &:hover {
          color: #0f77d8;
        }
        &:active {
          color: #1a90ff;
        }
      }
    }
  }
  .count_box {
    height: 60px;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    > div:first-child {
      margin-right: 15px;
      display: flex;
      > div:nth-child(2) {
        margin-left: 50px;
      }
      div {
        > span {
          color: #1a90ff;
          font-weight: bold;
        }
      }
    }
    > div:last-child {
      color: orange;
      padding-right: 30px;
    }
  }
  .classroom-manage {
    min-height: 996px;
    text-align: left;
    background: #fff;
    box-shadow: 0 0 10px #ddd;
    border-radius: 10px;
  }
  .action_box {
    text-align: left;
  }
  // delete:
  .dialog_inner_container_for_delete {
    .dialog_inner_container_for_delete_header {
      @include dialogTitle(#222);
    }
    .dialog_inner_container_for_delete_body {
      padding: 15px;
      text-align: center;
    }
    .dialog_inner_container_for_delete_footer {
      width: 100%;
      height: 70px;
      padding-bottom: 23px;
      @include verticalAndCrosswiseCenter();
      .dialog_inner_container_for_delete_footer_inner_item {
        width: 74px;
        height: 32px;
        @include verticalAndCrosswiseCenter();
        font-size: 12px;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
        box-shadow: 0 0 5px #f5f5f5;
        transition: all 0.5s;
        letter-spacing: 1px;
        &:nth-of-type(1) {
          &:hover {
            border: 1px solid #2090ff !important;
            color: #2090ff !important;
          }
        }
        &:nth-of-type(2) {
          &:hover {
            background-color: #48a2fc;
          }
        }
      }
    }
  }
}
</style>
